import { render } from "./PageNotFound.vue?vue&type=template&id=5dc53fb0&scoped=true"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"

import "./PageNotFound.vue?vue&type=style&index=0&id=5dc53fb0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc53fb0"]])

export default __exports__